// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"1d830174","188":"2bc07e76","239":"73ee9bd3","475":"8b0498db","528":"c721bcd0","616":"73ee9bd3"}[chunkId] + ".css";
};